import React, {useEffect, useState} from 'react';
import {Box, Divider, Grid, SxProps, Typography} from "@mui/material"
import DemoDatasetCard from "./DemoDatasetCard"
import {DemoDatasetJson} from "../../../api/json/DemoDatasetJson"
import {DemoDatasetRequests} from "../../../api/requests/DemoDatasetRequests"
import ApiError from "../../../api/ApiError"
import ErrorMessage from "../../error/ErrorMessage"
import animations from "../../../Animations.module.scss"
import {ProjectRequests} from "../../../api/requests/ProjectRequests"
import {useNavigate} from "react-router-dom"
import {useBackdrop} from "../../../hooks/useBackdrop"

interface DemoDatasetPickerProps {
    sx?: SxProps
}

function DemoDatasetPicker({sx}: DemoDatasetPickerProps) {
    const [demoDatasets, setDemoDatasets] = useState<DemoDatasetJson[]>()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<ApiError>()
    const [creating, setCreating] = useState(false)

    const {setBackdropOpen} = useBackdrop()

    const navigate = useNavigate()

    useEffect(() => {
        if (loading) return

        setLoading(true)
        DemoDatasetRequests.list(0)
            .then(response => {
                setError(undefined)
                setDemoDatasets(response.content)
            })
            .catch(setError)
            .finally(() => setLoading(false))
    }, [])

    const handleCreate = (dataset: DemoDatasetJson) => {
        if (creating) return

        setBackdropOpen(true)
        setCreating(true)
        ProjectRequests.create(dataset.name, dataset.type, dataset.id)
            .then(project => {
                setBackdropOpen(false)
                navigate(`/projects/${project.id}`)
            })
            .catch(setError)
            .finally(() => setCreating(false))
    }

    if (loading) {
        return <></>
    }

    if (!demoDatasets || demoDatasets.length === 0) {
        return <></>
    }

    return (
        <Box sx={sx} className={animations.defaultIn}>
            <Divider/>

            <Typography variant="h3" sx={{mt: 3}}>Try a demo dataset</Typography>
            <Typography variant="body2" sx={{color: '#888', mt: 0.5}}>
                Explore the platform with one of our curated datasets.
            </Typography>

            <Grid container spacing={2.5} sx={{mt: 1}}>
                {demoDatasets?.map((dataset) => (
                    <Grid item xs={12} sm={6} lg={4} key={dataset.id}>
                        <DemoDatasetCard dataset={dataset} onClick={handleCreate}/>
                    </Grid>
                ))}
            </Grid>

            <ErrorMessage error={error} sx={{mt: 2}}/>
        </Box>
    );
}

export default DemoDatasetPicker;
